import styled from "@emotion/styled";
import ApexCharts from "react-apexcharts";
import { itemTonGraphData } from "./itemMockupData";
import { itemPowerChartData } from "./powerMockupData";

interface ChartDataProps {
  itemCode?: string;
}

export const AnalysisPowerChart = ({ itemCode }: ChartDataProps) => {
  const chartData = itemCode ? itemPowerChartData[itemCode] : null;
  const pointData = itemCode ? itemTonGraphData[itemCode] : null;
  const defaultData = new Array(24).fill(0);

  const series = [
    {
      name: "개당 평균 소비 전력",
      type: "line",
      data: chartData?.line ?? defaultData,
    },
    {
      name: "전력 소비량",
      type: "bar",
      data: chartData?.bar ?? defaultData,
    },
  ];

  const yaxis = [
    {
      axisTicks: { show: true },
      axisBorder: { show: true, color: "#008FFB" },
      labels: { style: { colors: "#008FFB" } },
      title: {
        text: "개당 평균 소비 전력",
        style: { color: "#008FFB" },
      },
    },
    {
      opposite: true,
      axisTicks: { show: true },
      axisBorder: { show: true, color: "#00E396" },
      labels: { style: { colors: "#00E396" } },
      title: {
        text: "전력 소비량",
        style: { color: "#00E396" },
      },
    },
  ];

  const xaxisCategories =
    pointData?.categories ??
    chartData?.line?.map(
      (_, i) => `${String(i).padStart(2, "0")}-${String(i + 1).padStart(2, "0")}`,
    ) ??
    [];

  const options = {
    chart: {
      height: 350,
      type: "line" as const,
      stacked: false,
    },
    dataLabels: { enabled: false },
    stroke: { width: [2, 0] },
    xaxis: {
      categories: xaxisCategories,
    },
    yaxis,
  };

  return (
    <Container>
      {series.length > 0 ? (
        <ApexCharts options={options} series={series} type="line" height={350} />
      ) : (
        <div>그래프를 표시할 수 없습니다 (데이터 없음).</div>
      )}
    </Container>
  );
};

const Container = styled.div`
  width: 70%;
`;
